<template>
    <div>
        <div>
            <div class="col-md-12 row my-0 py-0 mx-auto" v-for="(item,index) in transactions">
                <div class="col-md-5">
                    <v-text-field
                            outlined
                            :label=" 'مبلغ '+ item.description"
                            :value="item.price | currency"
                            @input="priceIs(item,$event)"
                            dense
                            suffix="﷼"
                            clearable
                            @keypress="allowOnlyNumbers"
                            clear-icon="mdi-close-circle"
                            prepend-inner-icon="fa fa-pencil-alt"
                    >
                    </v-text-field>
                </div>
                <div class="col-md-5">
                    <date-picker
                            color="#00acc1"
                            label="تاریخ پرداخت"
                            input-class="mb-0 rounded"
                            persianDigits
                            v-model="item.expired_at"
                            clearable
                            :timezone="false"
                            format="YYYY-MM-DD"
                            style="font-size: 13px!important"
                            class="dateSet my-2"
                            display-format="jMMMM jD"
                    />
                </div>
                <div>
                    <v-btn small class="btn-add-with-text" fab icon @click="newTransaction">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn v-if="transactions.length>1" small class="btn-delete" fab icon @click="remove(index)">
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-btn @click="payInstallment" class="submit-btn">
                <span class="fa fa-save ml-1" style="font-size: 1.5rem"></span>
                ثبت درخواست
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: "addNew",
    props: {
        id: {
            default: ''
        },
        modal: {
            default: () => {
            },
            type: Function
        },
        reqAgain: {
            default: () => {
            },
            type: Function
        },
        transactionsCount: {
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            transactions: [{
                description: 'قسط' + ' ' + Number(this.transactionsCount + 1),
                price: '',
                expired_at: ''
            }],
        }
    },
    methods: {
        remove(id) {
            this.transactions.splice(id, 1);
            this.transactionsCount = this.transactionsCount - 1
        },
        newTransaction() {
            this.transactions.push({
                description: 'قسط' + ' ' + Number(this.transactionsCount + this.transactions.length + 1),
                price: '',
                expired_at: ''
            });
        },
        payInstallment() {
            this.requestApiPost('admin/form/createTransactionForPayment', {
                payment_id: this.id,
                transactions: this.transactions

            }).then(() => {
                this.$toast.success('درخواست شما با موفقیت ثبت شد.');
                this.modal();
                this.reqAgain();
            })
        },
        priceIs(transaction, value) {
            this.transactions[this.transactions.indexOf(transaction)].price = Number(value.replaceAll(",", ""));
        }
    },
    watch: {
        days(val) {
            this.count = val.length;
            this.transactions = [];
            val.forEach((item, index) => {
                this.transactions.push({
                    description: 'قسط' + ' ' + Number(this.transactionsCount + 1),
                    price: '',
                    expired_at: item
                },)
            });
        },
        finalPrice(val) {
            this.transactions = [];
            this.days.forEach((item, index) => {
                this.transactions.push({
                    description: 'قسط' + ' ' + Number(index + 1),
                    price: '',
                    expired_at: item
                },)
            });
        }
    },
    computed: {
        countPrice() {
            return this.finalPrice = this.mainPrice / this.count
        },
    }

}
</script>

<style>

</style>